module.exports = __webpack_public_path__ + "img/sam-rodriquez-skateboard.bc1aa56.jpg";